import { Sport } from '@optools/services/operator-gateway/types/generated/graphql';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export interface SportSelectProps {
  onValueChange: (sport: Sport) => void;
  value: Sport;
}

export function SportSelect({ onValueChange, value }: SportSelectProps) {
  return (
    <Select value={value} onValueChange={(value) => onValueChange(value as Sport)}>
      <SelectTrigger>
        <SelectValue />
      </SelectTrigger>
      <SelectContent align="start">
        <SelectItem value={Sport.MLB}>MLB</SelectItem>
        <SelectItem value={Sport.AAA}>AAA</SelectItem>
        <SelectItem value={Sport.AA}>AA</SelectItem>
        <SelectItem value={Sport.HIGH_A}>HIGH A</SelectItem>
        <SelectItem value={Sport.LOW_A}>LOW A</SelectItem>
      </SelectContent>
    </Select>
  );
}
